import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaClock } from "react-icons/fa";

const Support = () => {
  const [activeTab, setActiveTab] = useState('contact');
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    subject: '',
    issueDetails: '',
    priority: 'medium'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError(null);
    setSubmitSuccess(false);

    try {
      const response = await fetch('https://my-portfoli-backed.onrender.com/api/support', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fullName: formData.name,
          email: formData.email,
          subject: formData.subject,
          priority: getPriorityText(formData.priority),
          issueDetails: formData.message
        }),
      });

      if (!response.ok) {
        throw new Error('فشل في إرسال الطلب. الرجاء المحاولة مرة أخرى.');
      }

      const data = await response.json();
      console.log('Success:', data);
      setSubmitSuccess(true);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
        priority: 'medium'
      });
    } catch (error) {
      console.error('Error:', error);
      setSubmitError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getPriorityText = (priority) => {
    switch (priority) {
      case 'low':
        return 'منخفض';
      case 'medium':
        return 'متوسط';
      case 'high':
        return 'عالي';
      default:
        return 'متوسط';
    }
  };

  const styles = {
    container: {
      backgroundColor: '#ffffff',
      color: '#333333',
      minHeight: '100vh',
      padding: '4rem 2rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      lineHeight: '1.6'
    },
    content: {
      maxWidth: '900px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: '3rem',
      borderBottom: '2px solid #000000',
      paddingBottom: '1.5rem'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '0.5rem'
    },
    subtitle: {
      fontSize: '1.2rem',
      color: '#555555',
      fontWeight: '300'
    },
    tabs: {
      display: 'flex',
      marginBottom: '2rem',
      borderBottom: '1px solid #eeeeee'
    },
    tab: {
      padding: '0.8rem 1.5rem',
      cursor: 'pointer',
      fontWeight: '600',
      borderBottom: '3px solid transparent',
      transition: 'all 0.3s ease'
    },
    activeTab: {
      borderBottom: '3px solid #000000',
      color: '#000000'
    },
    inactiveTab: {
      color: '#555555'
    },
    tabContent: {
      padding: '1.5rem',
      backgroundColor: '#f9f9f9',
      borderRadius: '8px'
    },
    formGroup: {
      marginBottom: '1.5rem'
    },
    label: {
      display: 'block',
      marginBottom: '0.5rem',
      fontWeight: '600'
    },
    input: {
      width: '100%',
      padding: '0.8rem',
      border: '1px solid #dddddd',
      borderRadius: '4px',
      fontSize: '1rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    textarea: {
      width: '100%',
      padding: '0.8rem',
      border: '1px solid #dddddd',
      borderRadius: '4px',
      fontSize: '1rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      minHeight: '150px',
      resize: 'vertical'
    },
    select: {
      width: '100%',
      padding: '0.8rem',
      border: '1px solid #dddddd',
      borderRadius: '4px',
      fontSize: '1rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      backgroundColor: '#ffffff'
    },
    button: {
      backgroundColor: '#000000',
      color: '#ffffff',
      border: 'none',
      padding: '1rem 2rem',
      fontSize: '1rem',
      fontWeight: '600',
      borderRadius: '4px',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      opacity: isSubmitting ? 0.7 : 1,
      pointerEvents: isSubmitting ? 'none' : 'auto'
    },
    buttonHover: {
      backgroundColor: '#333333'
    },
    faqItem: {
      borderBottom: '1px solid #eeeeee',
      padding: '1.5rem 0',
      cursor: 'pointer'
    },
    faqQuestion: {
      fontSize: '1.2rem',
      fontWeight: '600',
      color: '#000000',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    faqAnswer: {
      fontSize: '1.1rem',
      color: '#555555',
      paddingTop: '1rem',
      lineHeight: '1.7'
    },
    contactInfo: {
      marginBottom: '1.5rem'
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1rem'
    },
    contactIcon: {
      marginLeft: '1rem',
      fontSize: '1.2rem',
      color: '#000000'
    },
    priorityHigh: {
      color: '#e74c3c',
      fontWeight: '600'
    },
    priorityMedium: {
      color: '#f39c12',
      fontWeight: '600'
    },
    priorityLow: {
      color: '#2ecc71',
      fontWeight: '600'
    },
    errorMessage: {
      color: '#e74c3c',
      marginBottom: '1rem',
      fontWeight: '600'
    },
    successMessage: {
      color: '#2ecc71',
      marginBottom: '1rem',
      fontWeight: '600'
    }
  };

  const faqs = [
    {
      question: "كم تستغرق من الوقت للرد على استفسارات الدعم؟",
      answer: "نهدف للرد على جميع استفسارات الدعم خلال 24 ساعة عمل. طلبات الدعم العاجل يتم الرد عليها خلال 4 ساعات كحد أقصى."
    },
    {
      question: "ما هي ساعات عمل الدعم الفني؟",
      answer: "خدمة الدعم الفني متاحة من الأحد إلى الخميس من الساعة 8 صباحاً حتى 5 مساءً. لدينا أيضًا دعم محدود في أيام الجمعة والسبت للقضايا الحرجة."
    },
    {
      question: "هل تقدمون دعمًا فوريًا عبر الهاتف؟",
      answer: "نعم، نقدم دعمًا هاتفيًا للقضايا الحرجة فقط. يمكنك طلب الدعم الهاتفي من خلال تعبئة نموذج الاتصال بنا واختيار 'عاجل' كدرجة الأولوية."
    },
    {
      question: "ما هي أنواع المشاكل التي يمكنكم مساعدتي بها؟",
      answer: "نقدم الدعم في جميع الجوانب الفنية المتعلقة بخدماتنا، بما في ذلك مشاكل التثبيت، الأخطاء البرمجية، استفسارات الاستخدام، مشاكل الأداء، وأي قضايا فنية أخرى."
    }
  ];

  const [activeFaqIndex, setActiveFaqIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveFaqIndex(activeFaqIndex === index ? null : index);
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <header style={styles.header}>
          <h1 style={styles.title}>مركز الدعم الفني</h1>
          <p style={styles.subtitle}>نحن هنا لمساعدتك في أي استفسار أو مشكلة تواجهك</p>
        </header>

        <div style={styles.tabs}>
          <div 
            style={{...styles.tab, ...(activeTab === 'contact' ? styles.activeTab : styles.inactiveTab)}}
            onClick={() => setActiveTab('contact')}
          >
            اتصل بنا
          </div>
          <div 
            style={{...styles.tab, ...(activeTab === 'faq' ? styles.activeTab : styles.inactiveTab)}}
            onClick={() => setActiveTab('faq')}
          >
            الأسئلة الشائعة
          </div>
          <div 
            style={{...styles.tab, ...(activeTab === 'resources' ? styles.activeTab : styles.inactiveTab)}}
            onClick={() => setActiveTab('resources')}
          >
            مصادر المساعدة
          </div>
        </div>

        {activeTab === 'contact' && (
<div style={styles.tabContent}>
  <div style={styles.contactInfo}>
    <h3 style={{ marginBottom: '1rem', fontSize: '1.3rem' }}>معلومات التواصل</h3>

    <div style={styles.contactItem}>
      <FaEnvelope style={{ marginRight: '10px' }} />
      <span>abdualrhmanmahrez@gmail.com</span>
    </div>

    <div style={styles.contactItem}>
      <FaPhone style={{ marginRight: '10px' }} />
      <span>+967 778 340 172</span>
    </div>

    <div style={styles.contactItem}>
      <FaClock style={{ marginRight: '10px' }} />
      <span>أوقات الدوام: الأحد - الخميس، 8 صباحًا - 5 مساءً</span>
    </div>
  </div>

            {submitError && <div style={styles.errorMessage}>{submitError}</div>}
            {submitSuccess && <div style={styles.successMessage}>تم استلام طلبك بنجاح، سنتواصل معك قريباً!</div>}

            <form onSubmit={handleSubmit}>
              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="name">الاسم الكامل</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="email">البريد الإلكتروني</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="subject">موضوع الرسالة</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="priority">أولوية الطلب</label>
                <select
                  id="priority"
                  name="priority"
                  value={formData.priority}
                  onChange={handleChange}
                  style={styles.select}
                >
                  <option value="low">منخفضة</option>
                  <option value="medium">متوسطة</option>
                  <option value="high">عاجلة</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="message">تفاصيل المشكلة</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  style={styles.textarea}
                  required
                />
              </div>

              <button 
                type="submit" 
                style={styles.button}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#333333'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#000000'}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'جاري الإرسال...' : 'إرسال الطلب'}
              </button>
            </form>
          </div>
        )}

        {activeTab === 'faq' && (
          <div style={styles.tabContent}>
            <h3 style={{marginBottom: '1.5rem', fontSize: '1.3rem'}}>الأسئلة الشائعة للدعم الفني</h3>
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                style={styles.faqItem}
                onClick={() => toggleFaq(index)}
              >
                <div style={styles.faqQuestion}>
                  {faq.question}
                  <span>{activeFaqIndex === index ? '−' : '+'}</span>
                </div>
                {activeFaqIndex === index && (
                  <div style={styles.faqAnswer}>{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        )}

        {activeTab === 'resources' && (
          <div style={styles.tabContent}>
            <h3 style={{marginBottom: '1.5rem', fontSize: '1.3rem'}}>مصادر المساعدة الذاتية</h3>
            
            <div style={{marginBottom: '2rem'}}>
              <h4 style={{marginBottom: '1rem', fontSize: '1.1rem', fontWeight: '600'}}>وثائق التطوير</h4>
              <ul style={{paddingLeft: '1.5rem', lineHeight: '1.8'}}>
                <li><a href="https://my-portfoli-backed.onrender.com/blogs/686e3f72ef602d0a809a0232" style={{color: '#0066cc'}}>دليل استخدام واجهة برمجة التطبيقات (API)</a></li>
                <li><a href="https://my-portfoli-backed.onrender.com/blogs/686e45e8ef602d0a809a0237" style={{color: '#0066cc'}}>أفضل الممارسات لتطوير التطبيقات</a></li>
                <li><a href="https://my-portfoli-backed.onrender.com/blogs/686e4ee8ef602d0a809a0240" style={{color: '#0066cc'}}>دليل استكشاف الأخطاء وإصلاحها</a></li>
                <li><a href="https://my-portfoli-backed.onrender.com/blogs/686e5024ef602d0a809a0244" style={{color: '#0066cc'}}>نماذج كود جاهزة للاستخدام</a></li>
              </ul>
            </div>

            {/* <div style={{marginBottom: '2rem'}}>
              <h4 style={{marginBottom: '1rem', fontSize: '1.1rem', fontWeight: '600'}}>فيديوهات تعليمية</h4>
              <ul style={{paddingLeft: '1.5rem', lineHeight: '1.8'}}>
                <li><a href="#" style={{color: '#0066cc'}}>سلسلة تعلم استخدام النظام</a></li>
                <li><a href="#" style={{color: '#0066cc'}}>نصائح لتحسين الأداء</a></li>
                <li><a href="#" style={{color: '#0066cc'}}>حلول للمشاكل الشائعة</a></li>
              </ul>
            </div> */}

            {/* <div>
              <h4 style={{marginBottom: '1rem', fontSize: '1.1rem', fontWeight: '600'}}>مجتمع الدعم</h4>
              <ul style={{paddingLeft: '1.5rem', lineHeight: '1.8'}}>
                <li><a href="#" style={{color: '#0066cc'}}>منتدى المطورين</a></li>
                <li><a href="#" style={{color: '#0066cc'}}>قناة Slack للدعم الفني</a></li>
                <li><a href="#" style={{color: '#0066cc'}}>مجموعة GitHub للمناقشات</a></li>
              </ul>
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default Support;